// app/javascript/controllers/chat_scroll_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bottom"]

  connect() {
    this.scrollToLatest()
  }

  scrollToLatest() {
    if (!this.hasBottomTarget) return
    // Ensures we land at newest message after full reload
    this.bottomTarget.scrollIntoView({ block: "end" })
  }
}
